import React, { useEffect, useState } from 'react';
import { Text } from '@grupoboticario/flora-react';
import Styled from './ProductPriceStyled';
import { IProduct } from 'src/common/types/CatalogType';
import { convertCurrency } from 'src/common/helpers';

interface IProductPrice extends Pick<IProduct, 'price' | 'discountPrice'> {} //NOSONAR

const ProductPrice = (props: IProductPrice): JSX.Element => {
  const [price, setPrice] = useState('');
  const [discountPrice, setDiscountPrice] = useState('');

  useEffect(() => {
    if (props.price) {
      setPrice(convertCurrency(props.price));
    }
    if (props.discountPrice) {
      setDiscountPrice(convertCurrency(props.discountPrice));
    }
  }, [props.price, props.discountPrice]);

  return (
    <Styled.PriceContainer
      aria-label={`${
        props.discountPrice < props.price ? `de ${price} por ` : ''
      }${discountPrice}`}
    >
      {props.discountPrice < props.price && (
        <Text
          data-testid="price"
          size="auxiliarSmall"
          css={{ fontFamily: '$primary' }}
        >
          de{' '}
          <span style={{ textDecoration: 'line-through rgb(222, 22, 22)' }}>
            {price}
          </span>{' '}
          por
        </Text>
      )}
      <Text
        data-testid="discountPrice"
        size="bodyLargeShort"
        css={{ fontFamily: '$primary' }}
      >
        {discountPrice}
      </Text>
    </Styled.PriceContainer>
  );
};

export default ProductPrice;
